import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentPost = {
  path: "/consent",
  method: RouteHttpVerb.POST,
  obfuscatePath: "keep-last-part"
};